<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22 16a2.5 2.5 0 00-2-2.05V13a8 8 0 00-4-6.91V5a1 1 0 00-1-1H9a1 1 0 00-1 1v1.09A8 8 0 004 13v.92a2.5 2.5 0 00.1 4.92 48.77 48.77 0 007.9.66 48.77 48.77 0 007.9-.66A2.5 2.5 0 0022 16zm-2.39.89a45.92 45.92 0 01-15.16 0A.49.49 0 014 16.3a.48.48 0 01.2-.33.47.47 0 01.38-.09L6 16.1V13a6 6 0 012-4.46V11a1 1 0 002 0V6h4v5a1 1 0 002 0V8.53A6 6 0 0118 13v3.1l1.42-.22a.47.47 0 01.37.09.48.48 0 01.2.33.49.49 0 01-.41.57z"/></svg>